// Helpers de formato compartidos, tipados. Primer módulo en TypeScript:
// la migración a TS es incremental — los archivos JS conviven (allowJs).

export type Currency = 'UYU' | 'USD';

// Sin decimales salvo que el valor los tenga (nunca se inventan ni se recortan).
export function formatMoney(n: number | string | null | undefined, currency: Currency = 'UYU'): string {
  const v = Number(n) || 0;
  const dec = Number.isInteger(Math.round(v * 100) / 100) ? 0 : 2;
  return new Intl.NumberFormat('es-UY', {
    style: 'currency',
    currency,
    minimumFractionDigits: dec,
    maximumFractionDigits: dec,
  }).format(v);
}

// Igual que formatMoney pero sin símbolo de moneda (solo el número).
export function formatNumber(n: number | string | null | undefined): string {
  const v = Number(n) || 0;
  const dec = Number.isInteger(Math.round(v * 100) / 100) ? 0 : 2;
  return new Intl.NumberFormat('es-UY', { minimumFractionDigits: dec, maximumFractionDigits: dec }).format(v);
}

// "2026-07-06" (o ISO) → "06/07/2026".
export function formatDate(str: string | null | undefined): string {
  if (!str) return '';
  const d = str.split('T')[0];
  const [y, m, dd] = d.split('-');
  return `${dd}/${m}/${y}`;
}

// Hora almacenada ("HH:MM") -> display operativo uniforme: siempre "HH:MM".
export function formatTime(v: string | null | undefined): string {
  if (!v) return '';
  const normalized = parseTime(String(v).slice(0, 5));
  const [h = '', m = ''] = normalized.split(':');
  if (!h) return '';
  return `${h.padStart(2, '0')}:${(m || '00').padStart(2, '0')}`;
}

// Input flexible del usuario → "HH:MM" para almacenar. Acepta "8", "08", "830",
// "8:30", "8.30", "18:30", "1830"… y siempre devuelve la hora normalizada.
export function parseTime(v: string | null | undefined): string {
  const s = String(v ?? '').trim();
  if (!s) return '';
  const sep = s.match(/^(\d{1,2})[.:](\d{1,2})$/);   // 8:30 · 8.30 · 18:30
  if (sep) return `${sep[1].padStart(2, '0')}:${sep[2].padStart(2, '0')}`;
  if (/^\d{1,4}$/.test(s)) {                          // 8 · 08 · 830 · 1830
    if (s.length <= 2) return `${s.padStart(2, '0')}:00`;
    const p = s.padStart(4, '0');
    return `${p.slice(0, 2)}:${p.slice(2)}`;
  }
  return s;
}
